/** Dutch + English stopwords when deriving project-pill initials. */
export const PROJECT_PILL_STOPWORDS = new Set(
  [
    'en',
    'de',
    'het',
    'van',
    'voor',
    'in',
    'op',
    'met',
    'aan',
    'bij',
    'and',
    'the',
    'a',
    'an',
    'for',
    'in',
    'on',
    'with',
    'at',
    'by',
    'to',
    'of',
  ].map((w) => w.toLowerCase()),
);

/**
 * Word-initial abbreviation for responsive project pills (max 3 letters).
 * @param {string} name
 */
export function abbreviateProjectDisplayName(name) {
  const trimmed = String(name ?? '').trim();
  if (!trimmed) return '';

  const words = trimmed.split(/\s+/).filter(Boolean);
  const meaningful = words.filter(
    (w) => !PROJECT_PILL_STOPWORDS.has(w.toLowerCase()),
  );
  const source = meaningful.length > 0 ? meaningful : words;

  if (source.length >= 3) {
    return source
      .slice(0, 3)
      .map((w) => w[0])
      .join('')
      .toUpperCase();
  }

  if (source.length === 2) {
    return `${source[0][0]}${source[1][0]}`.toUpperCase();
  }

  const word = source[0] ?? trimmed;
  return word.slice(0, Math.min(3, word.length)).toUpperCase();
}
